import classNames from 'classnames';



export default class DpitMultiStateBtn {


	/**
	 * 
	 * @param {Function} onClickCB
	 * @param {object} statesOptions 
	 * { 'default': 'Default state label', 'success': 'Success message', 'error':'Error message' }
	 * @param {string} initState
	 * @param {string} bemRootClass
	 * @param {Array|string} additionalClasses
	 * @param {string} id
	 * @param {string} htmlTag
	 */
	constructor(onClickCB, statesOptions = {}, initState = 'default', bemRootClass = 'dpit-btn', additionalClasses = [], inactive = false, id = '', htmlTag = 'div') {
		this.element = document.createElement(htmlTag);
		if (id) this.element.id = id;
		this.element.setAttribute('role', 'button');
		if (typeof additionalClasses === 'string') this.element.className = classNames([bemRootClass, additionalClasses]);
		else this.element.className = classNames([bemRootClass, [...additionalClasses]]);

		this.element.addEventListener('click', this.onClickHandler);
		this.btnBemClass = bemRootClass;
		this.initStates(statesOptions, bemRootClass);
		this.setOnlyState(initState);
		this.onClickCB = onClickCB;
		if (inactive) this.deactivate();
	}

	activate() {
		this.removeStateClass('inactive');
	}

	deactivate() {
		this.addStateClass('inactive');
	}


	renderContent(stateEl, stateContent) {
		if (stateContent !== null && stateContent !== undefined) {
			if (stateContent instanceof HTMLElement) { stateEl.appendChild(stateContent); return true; }
			else if (typeof stateContent === 'string') { stateEl.innerHTML = stateContent; return true; }
		}
		return false;
	}

	initStates(statesOptions, btnBemClass) {
		this.stateOptions = {};
		this.stateKeys = Object.keys(statesOptions);
		this.stateKeys.forEach(state => {
			const stateEl = document.createElement('div');
			const contentBemClassBase = btnBemClass + '__content';
			stateEl.classList.add(contentBemClassBase);
			stateEl.classList.add(contentBemClassBase + '--' + state);

			const stateOption = statesOptions[state];
			if (stateOption) {

				let stateContent = null;
				let newStateOption = null;
				if (typeof stateOption === 'object') {
					stateContent = stateOption.content;
					newStateOption = { ...stateOption, element: stateEl };
				}
				else {
					stateContent = stateOption;
					newStateOption = { content: stateOption, element: stateEl };
				}
				if (this.renderContent(stateEl, stateContent)) {

					this.element.appendChild(stateEl);
					this.stateOptions[state] = newStateOption;
				}
			}
		});
	}

	getButtonElement() {
		return this.element;
	}

	destroy() {
		this.element?.removeEventListener('click', this.onClickHandler);
	}

	deactivateAll() {
		this.setOnlyState();
	}


	clearActiveClasses(state) {
		if (state) {
			const stateOption = this.stateOptions[state];
			this.removeStateClass(stateOption.activeMod);
			if (stateOption?.activeClass) this.element.classList.remove(stateOption.activeClass);
		}
	}

	setActiveClasses(state) {
		const stateOption = this.stateOptions[state];
		if (stateOption) {
			this.addStateClass(stateOption.activeMod);
			if (stateOption?.activeClass) this.element.classList.add(stateOption.activeClass);
		}
	}

	removeStateClass(state) {
		if (state) this.element.classList.remove(this.btnBemClass + '--' + state);
	}

	addStateClass(state) {
		if (state) this.element.classList.add(this.btnBemClass + '--' + state);
	}

	setOnlyStateTemporarily(state, followingState = '', timeout = 3000) {
		followingState = followingState ? followingState : this.currentState;
		this.setOnlyState(state);
		if (followingState) {
			setTimeout(() => {
				this.setOnlyState(followingState);
			}, timeout);
		}
	}

	setOnlyState(state = '') {  // '' => deactivate
		this.removeStateClass(this.currentState);
		this.clearActiveClasses(this.currentState);
		this.stateKeys.forEach(key => {
			if (this.stateOptions[key]?.element) {
				if (state === key) {
					this.addStateClass(key);
					this.setActiveClasses(key);
				}
				this.stateOptions[key].element.style.display = state === key ? '' : 'none';
			}
		});
		this.currentState = state;
	}

	onClickHandler = (event) => {
		if (this.bulletsAnimation.isRunning) {
			event.stopPropagation();
			event.preventDefault();
			return false;
		}
		else if (this.onClickCB instanceof Function) {
			this.onClickCB({ state: this.currentState, button: this });
		}
	};

}